import { useEffect, useState } from 'react';
import OfficeModal from '../AdminComponent/OfficeModal';
import ServiceModal from './ServiceModal';
import AddCapacidadModal from '../AdminComponent/CapacityModal';
import CrearConsentimientoModal from './CrearConsentimientoModal';
import CrearHistoriaModal from './CrearHistoriaModal';
import TableDocuments from './TableDocuments';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import Cargando from '../../utils/Cargando';
import Contenedor from '../GlobalComponents/Contenedor';
import { ReactComponent as Perfil } from "../../assets/icons/perfilUsuario.svg";
import { useDataUser } from '../../context/dataUserContext';

const ClinicProfile = () => {
    const [clinicData, setClinicData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('perfil');
    const [editIndex, setEditIndex] = useState(null);
    const [editableSede, setEditableSede] = useState(null);
    const [editableCapacidad, setEditableCapacidad] = useState(null);
    const [editableFormato, setEditableFormato] = useState(null);
    const [editableServicio, setEditableServicio] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConsentimientoModalOpen, setConsentimientoModalOpen] = useState(false);
    const [isHistoriaModalOpen, setHistoriaModalOpen] = useState(false);
    const [modalTipoFormato, setModalTipoFormato] = useState('');
    const { clinicId } = useDataUser();

    const handleOpenConsentimientoModal = (tipoFormato) => {
        setConsentimientoModalOpen(true);
        setModalTipoFormato(tipoFormato);
    }
    const handleCloseConsentimientoModal = () => {
        setModalTipoFormato('');
        setConsentimientoModalOpen(false);
    }

    const handleOpenHistoriaModal = (tipoFormato) => {
        setHistoriaModalOpen(true);
        setModalTipoFormato(tipoFormato);
    }
    const handleCloseHistoriaModal = () => {
        setHistoriaModalOpen(false);
        setModalTipoFormato('');
    }

    const fetchClinicProfile = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/${clinicId}`);
            setClinicData(response.data);
            console.log(response.data.sedes);
            setLoading(false);
        } catch (err) {
            setError('Error al obtener los datos de la clínica');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClinicProfile();
    }, [clinicId]);

    if (loading) return <Cargando />;
    if (error) return <p className="text-center text-red-600">{error}</p>;

    const saveSedeChanges = async (updatedSede) => {
        try {
            const response = await apiClient.put(`/api/clinic/updateSede/${updatedSede._id}`, updatedSede);

            if (response.status === 200) {
                const updatedClinicData = {
                    ...clinicData,
                    sedes: clinicData.sedes.map((sede) =>
                        sede._id === updatedSede._id ? response.data.updatedSede : sede
                    ),
                };
                setClinicData(updatedClinicData);
                setEditIndex(null);
                setEditableSede(null);
                alertaGeneral({
                    titulo: '¡Sede Actualizada con éxito!',
                });
            } else {
                console.error('Error al actualizar la sede:', response.data.message);
            }
        } catch (error) {
            console.error('Error al actualizar la sede:', error);
        }
    };
    const saveFormatoChanges = async (updatedFormato) => {
        try {
            const dataToSend = {
                ...updatedFormato,
                clinicInfo: clinicId
            };

            const response = await apiClient.put(`/api/clinic/updateFormato/${updatedFormato._id}`, dataToSend);
            if (response.status === 200) {
                fetchClinicProfile();
                setEditIndex(null);
                setEditableFormato({});
            }
            alertaGeneral({
                titulo: "¡Formato Actualizado con éxito!",
            });
        } catch (error) {
            console.error('Error al actualizar formato:', error);
        }
    };

    const saveCapacidadChanges = async (updatedCapacidad) => {
        try {
            const response = await apiClient.put(`/api/clinic/updateCapacidad/${updatedCapacidad._id}`, updatedCapacidad);

            if (response.status === 200) {
                const updatedClinicData = {
                    ...clinicData,
                    capacidades: clinicData.capacidades.map((capacidad) =>
                        capacidad._id === updatedCapacidad._id ? response.data.updatedCapacidad : capacidad
                    ),
                };
                setClinicData(updatedClinicData);
                setEditableCapacidad(null);
                alertaGeneral({
                    titulo: '¡Capacidad Actualizada con éxito!',
                });
            } else {
                console.error('Error al actualizar la capacidad:', response.data.message);
            }
        } catch (error) {
            console.error('Error al actualizar la capacidad:', error);
        }
    };
    const saveServicioChanges = async (updatedServicios) => {
        try {
            const response = await apiClient.put(`/api/clinic/updateServicios/${updatedServicios._id}`, updatedServicios);

            if (response.status === 200) {
                const updatedClinicData = {
                    ...clinicData,
                    servicios: clinicData.servicios.map((servicios) =>
                        servicios._id === updatedServicios._id ? response.data.updatedServicios : servicios
                    ),
                };
                setClinicData(updatedClinicData);
                setEditIndex(null);
                fetchClinicProfile();
                alertaGeneral({
                    titulo: "¡Servicio Actualizado con éxito!",
                });
            } else {
                console.error('Error al actualizar la capacidad:', response.data.message);
            }
        } catch (error) {
            console.error('Error al actualizar la capacidad:', error);
        }
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };


    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleSaveSede = async (formData) => {
        try {
            const dataToSend = {
                ...formData,
                clinicInfo: clinicId // Añadir el clinicInfo a los datos que se van a enviar
            };

            const response = await apiClient.post(`/api/clinic/createSede`, dataToSend);
            fetchClinicProfile();
            console.log('Sede creada:', response.data);
            setIsModalOpen(false);

            alertaGeneral({
                titulo: '¡Sede Creada con éxito!',
            });
        } catch (error) {
            console.error('Error al crear la sede:', error);
        }
    };
    const handleSaveFormato = async (formData) => {
        console.log('modalTipoFormato:', modalTipoFormato); // Verifica el valor de modalTipoFormato

        try {
            const dataToSend = {
                ...formData,
                clinicInfo: clinicId
            };

            const response = await apiClient.post(`/api/clinic/createFormato/${modalTipoFormato}`, dataToSend);
            setEditableFormato('');
            fetchClinicProfile();
            console.log(`${modalTipoFormato} creado:`, response.data);
            setIsModalOpen(false);

            alertaGeneral({
                titulo: `${modalTipoFormato.charAt(0).toUpperCase() + modalTipoFormato.slice(1)} creado con éxito!`
            });
        } catch (error) {
            console.error(`Error al crear ${modalTipoFormato}:`, error);
        }
    };




    const handleSaveCapacidad = async (formData) => {
        try {
            const dataToSend = {
                ...formData,
                clinicInfo: clinicId
            };

            const response = await apiClient.post(`/api/clinic/createCapacidad`, dataToSend);
            fetchClinicProfile();
            console.log('Capacidad creada:', response.data);
            setIsModalOpen(false);
            alertaGeneral({
                titulo: '¡Capacidad creada con éxito!',
            });
        } catch (error) {
            console.error('Error al crear la capacidad:', error);
        }
    };

    const handleBack = () => {
        setEditIndex(null);
        setEditableSede(null);
        setEditableCapacidad(null);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditableSede({ ...editableSede, [name]: value });
    };

    const handleCapacidadInputChange = (e) => {
        const { name, value } = e.target;
        setEditableCapacidad({ ...editableCapacidad, [name]: value });
    };

    const documentsExists = []

    const renderTabContent = () => {
        switch (activeTab) {
            case 'perfil':
                return (
                    <div>
                        <form className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="form-group ">
                                <label className="form-label">Nombre del proveedor:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.providerName}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Código del Proveedor:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.providerCode}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Identificación:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.identification}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Clase del Proveedor:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.providerClass}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Código de Sede Principal:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.mainHeadquartersCode}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Email:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.email}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Naturaleza Jurídica:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.legalNature}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Ciudad Principal:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.mainCity}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Departamento Principal:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.mainDepartment.departamento}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Teléfono:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.phone}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Empresa de Estado Social:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.stateSocialCompany}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Carácter Territorial:</label>
                                <input
                                    type="text"
                                    value={clinicData.clinic.territorialCharacter}
                                    readOnly
                                    className="form-input"
                                />
                            </div>
                            {/* Agregar otros campos del perfil según sea necesario */}
                            <span />
                        </form>
                        <TableDocuments
                            lstDocuments={documentsExists}
                        />
                    </div>
                );
            case 'sedes':
                return (
                    <div className="w-full">
                        <div className='flex justify-end'>
                            <button
                                onClick={handleOpenModal}
                                className="button-add">
                                Agregar Sede
                            </button>

                            <OfficeModal
                                isOpen={isModalOpen}
                                onClose={handleCloseModal}
                                onSave={handleSaveSede}
                            />
                        </div>
                        {clinicData.sedes.map((sede, index) => (
                            <div key={sede._id}>
                                <span className="px-2 font-bold text-lg text-left text-[#205087ff]"> {sede.name} &nbsp;-&nbsp; {sede.code} </span>
                                <hr className="bg-[#205087ff] h-[2px] w-full" />

                                <div className="bg-gray-200 my-3 p-4 rounded-lg">
                                    {editIndex === index ? (
                                        <>
                                            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Nombre:</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={editableSede.name}
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Dirección:</label>
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        value={editableSede.address}
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Telefono:</label>
                                                    <input
                                                        type="text"
                                                        name="phone"
                                                        value={editableSede.phone}
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Correo:</label>
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        value={editableSede.email}
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Codigo:</label>
                                                    <input
                                                        type="text"
                                                        name="code"
                                                        value={editableSede.code}
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="col-span-1">
                                                    <label className="form-label text-black">Principal</label>
                                                    <input
                                                        type="text"
                                                        name="isMain"
                                                        value={editableSede.isMain ? 'Sí' : 'No'}
                                                        readOnly
                                                        onChange={handleInputChange}
                                                        className="form-input"
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-2 flex justify-end gap-2">
                                                <button
                                                    onClick={() => saveSedeChanges(editableSede)}
                                                    className="button-add"
                                                >
                                                    Guardar
                                                </button>
                                                <button
                                                    onClick={handleBack}
                                                    className="button-gray"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                                <div className="grid col-span-1 gap-2">
                                                    <p><strong>Departamento:</strong> {sede.departmentName}</p>

                                                    <p><strong>Ciudad:</strong> {sede.mainCity}</p>

                                                    <p><strong>Dirección:</strong> {sede.address}</p>

                                                    <p><strong>Telefono:</strong> {sede.phone}</p>
                                                </div>
                                                <div className="grid col-span-1 gap-2">
                                                    <p><strong>Correo electrónico:</strong> {sede.email}</p>

                                                    <p><strong>Zona:</strong> {sede.zone}</p>

                                                    <p><strong>Nivel de atención:</strong> {sede.attetionLevel}</p>

                                                    <p><strong>Complejidad:</strong> {sede.complexity}</p>

                                                    {/* <p><strong>Principal:</strong> {sede.isMain ? 'Sí' : 'No'}</p> */}
                                                </div>
                                            </div>
                                            <div className="flex justify-end">
                                                <button
                                                    onClick={() => {
                                                        setEditIndex(index);
                                                        setEditableSede(sede);
                                                    }}
                                                    className="button-gray"
                                                >
                                                    Editar
                                                </button>
                                            </div>
                                        </>

                                    )}
                                </div>
                            </div>
                        ))
                        }
                    </div >
                );

            case 'capacidades':
                return (
                    <div>
                        <div className='flex justify-end'>
                            <button
                                onClick={handleOpenModal}
                                className="button-add">
                                Agregar capacidad
                            </button>
                            <AddCapacidadModal
                                isOpen={isModalOpen}
                                onClose={handleCloseModal}
                                onSave={handleSaveCapacidad}
                                sedes={clinicData.sedes}
                            />
                        </div>

                        <span className="px-2 font-bold text-lg text-left text-[#205087ff]">Capacidades</span>
                        <hr className="bg-[#205087ff] h-[2px] w-full" />

                        {clinicData.capacidades.map((capacidad) => (
                            <div key={capacidad._id} className="my-4 p-4 bg-gray-200 rounded-lg">
                                {editableCapacidad?._id === capacidad._id ? (
                                    <div>
                                        <div className="flex items-center form-group gap-2">
                                            <label><strong>Concepto:</strong></label>
                                            <input
                                                type="text"
                                                name="concept"
                                                readOnly
                                                value={editableCapacidad.concept}
                                                onChange={handleCapacidadInputChange}
                                                className="form-input bg-gray-300 py-1 w-fit"
                                            />
                                        </div>
                                        <div className="flex items-center form-group gap-2">
                                            <label><strong>Grupo:</strong></label>
                                            <input
                                                type="text"
                                                name="group"
                                                readOnly
                                                value={editableCapacidad.group}
                                                onChange={handleCapacidadInputChange}
                                                className="form-input bg-gray-300 py-1 w-fit"
                                            />
                                        </div>
                                        <div className="flex items-center form-group gap-2">
                                            <label><strong>Cantidad:</strong></label>
                                            <input
                                                type="number"
                                                name="quantity"
                                                value={editableCapacidad.quantity}
                                                onChange={handleCapacidadInputChange}
                                                className="form-input py-1 w-fit"
                                            />
                                        </div>
                                        <div className="flex items-center form-group gap-2">
                                            <label><strong>Codigo Sede:</strong></label>
                                            <input
                                                type="text"
                                                value={capacidad.sedeCode} // No editable
                                                readOnly
                                                className="form-input bg-gray-300 py-1 w-fit"
                                            />
                                        </div>
                                        <div className="flex items-center form-group gap-2">
                                            <label><strong>Nombre Sede:</strong></label>
                                            <input
                                                type="text"
                                                value={capacidad.sedeName} // No editable
                                                readOnly
                                                className="form-input bg-gray-300 py-1 w-fit"
                                            />
                                        </div>
                                        <div className="flex justify-end gap-3">
                                            <button
                                                onClick={() => saveCapacidadChanges(editableCapacidad)}
                                                className="button-send"
                                            >
                                                Guardar
                                            </button>
                                            <button
                                                onClick={() => setEditableCapacidad(null)}
                                                className="button-gray"
                                            >
                                                Volver
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="grid grid-cols-1">
                                        <div className="grid col-span-1 gap-2">
                                            <p><strong>Concepto:</strong> {capacidad.concept}</p>
                                            <p><strong>Grupo:</strong> {capacidad.group}</p>
                                            <p><strong>Cantidad:</strong> {capacidad.quantity}</p>
                                            <p><strong>Codigo Sede:</strong> {capacidad.sedeCode}</p>
                                            <p><strong>Nombre Sede:</strong> {capacidad.sedeName}</p>
                                        </div>
                                        <div className="col-span-1 flex justify-end">
                                            <button
                                                onClick={() => setEditableCapacidad(capacidad)}
                                                className="button-gray"
                                            >
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                );

            case 'servicios':
                return (
                    <div>
                        <div className='flex justify-end'>
                            <button
                                onClick={handleOpenModal}
                                className="button-add"
                            >
                                Agregar servicio
                            </button>
                            <ServiceModal
                                isOpen={isModalOpen}
                                onClose={handleCloseModal}
                                render={fetchClinicProfile}
                                sedes={clinicData.sedes}
                            />
                        </div>

                        {clinicData.servicios.map((servicio, index) => (
                            <div key={servicio._id}>

                                <span className="px-2 text-lg text-[#205087ff] font-bold"> {servicio.service} </span>
                                <hr className="bg-[#205087ff] h-[2px] w-full" />

                                <div class="my-3 p-4 bg-gray-200 rounded-lg">

                                    {editIndex === index ? (
                                        <div>
                                            <div className="flex items-center gap-2">
                                                <label><strong>Valor consulta:</strong></label>
                                                <input
                                                    type="number"
                                                    value={editableServicio.consultationValue}
                                                    onChange={(e) => {
                                                        const newValue = parseFloat(e.target.value) || 0;
                                                        setEditableServicio({
                                                            ...editableServicio,
                                                            consultationValue: newValue,
                                                            netValue: newValue + parseFloat(editableServicio.copayValue) || 0
                                                        });
                                                    }}
                                                    className="w-fit form-input"
                                                />
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <label><strong>Valor cuota moderadora:</strong></label>
                                                <input
                                                    type="number"
                                                    value={editableServicio.copayValue}
                                                    onChange={(e) => {
                                                        const newValue = parseFloat(e.target.value) || 0;
                                                        setEditableServicio({
                                                            ...editableServicio,
                                                            copayValue: newValue,
                                                            netValue: newValue + parseFloat(editableServicio.consultationValue) || 0
                                                        });
                                                    }}
                                                    className="w-fit form-input"
                                                />
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <label><strong>Valor neto:</strong></label>
                                                <input
                                                    type="number"
                                                    value={editableServicio.netValue}
                                                    readOnly
                                                    className="w-fit form-input bg-gray-100"
                                                />
                                            </div>

                                            <div className="flex justify-end my-2 gap-2">
                                                <button
                                                    onClick={() => saveServicioChanges({
                                                        ...editableServicio,
                                                        consultationValue: parseFloat(editableServicio.consultationValue),
                                                        copayValue: parseFloat(editableServicio.copayValue),
                                                        netValue: parseFloat(editableServicio.netValue)
                                                    })}
                                                    className="button-send"
                                                >
                                                    Guardar
                                                </button>
                                                <button
                                                    onClick={() => setEditIndex(null)}
                                                    className="button-gray"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="grid grid-cols-1 md:grid-cols-2">
                                                <div className="grid col-span-1 gap-2">
                                                    <p><strong>Grupo:</strong> {servicio.group}</p>
                                                    <p><strong>Cuota moderadora:</strong> ${servicio.copayValue} COP</p>
                                                    <p><strong>Valor consulta:</strong> ${servicio.consultationValue} COP</p>
                                                    <p><strong>Valor neto:</strong> ${servicio.netValue} COP</p>
                                                </div>
                                                <div class="grid col-span-1 gap-2">
                                                    <p><strong>Nombre sede:</strong> {servicio.sedeName}</p>
                                                    <p><strong>Codigo sede:</strong> {servicio.sedeCode}</p>
                                                    <p><strong>Modalidad:</strong> {servicio.modality}</p>
                                                </div>
                                            </div>
                                            <div className="flex justify-end">
                                                <button
                                                    onClick={() => {
                                                        setEditIndex(index);
                                                        setEditableServicio(servicio);
                                                    }}
                                                    className="button-gray"
                                                >
                                                    Editar
                                                </button>
                                            </div>
                                            <TableDocuments
                                                lstDocuments={[{ nameToSave: 'sede_clinica_documento_habilitacion', name: 'Documento Habilitación', url: servicio.urlHabilitationDocument || '', isEdit: false }]}
                                            />
                                        </div>

                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                );
            case 'formatos':
                return (
                    <div>
                        <div className="flex justify-end space-x-4 mb-4">
                            <button
                                onClick={() => handleOpenConsentimientoModal('consentimiento')}
                                className="button-add"
                            >
                                Crear Consentimiento
                            </button>
                            <button
                                onClick={() => handleOpenHistoriaModal('historia')}
                                className="button-add"
                            >
                                Crear Historia Clínica
                            </button>
                        </div>

                        <CrearConsentimientoModal
                            isOpen={isConsentimientoModalOpen}
                            onClose={() => {
                                handleCloseConsentimientoModal();
                                setEditableFormato({}); // Reiniciar valores del formato editable
                            }}
                            servicios={clinicData.servicios}
                            onSave={handleSaveFormato}
                        />

                        <CrearHistoriaModal
                            isOpen={isHistoriaModalOpen}
                            onClose={() => {
                                handleCloseHistoriaModal();
                                setEditableFormato({}); // Reiniciar valores del formato editable
                            }}
                            servicios={clinicData.servicios}
                            onSave={handleSaveFormato}
                        />
                        <div className="grid grid-cols-2 gap-8">
                            <div>
                                <h4 className="px-2 text-lg text-[#205087ff] font-bold">
                                    Consentimientos
                                </h4>
                                <hr className="bg-[#205087ff] h-[2px] w-full" />
                                {clinicData.formatos?.consentimientos?.map((consentimiento, index) => (
                                    <div key={consentimiento._id} className="my-3 p-4 bg-gray-200 rounded-lg">
                                        {editIndex === `consentimiento-${index}` ? (
                                            <div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="flex text-gray-700 font-semibold mb-1">Nombre del consentimiento:</label>
                                                    <input
                                                        type="text"
                                                        value={editableFormato.nombreConsentimiento || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, nombreConsentimiento: e.target.value })}
                                                        className="form-input w-fit py-1"
                                                        placeholder="Nombre del consentimiento"
                                                    />
                                                </div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="flex text-gray-700 font-semibold mb-1">Servicio Ligado:</label>
                                                    <select
                                                        value={editableFormato.servicioLigado || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, servicioLigado: e.target.value })}
                                                        className="form-input w-fit py-1"
                                                    >
                                                        {clinicData.servicios.map((servicio) => (
                                                            <option key={servicio._id} value={servicio.service}>
                                                                {servicio.service}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="flex text-gray-700 font-semibold mb-1">Consentimiento:</label>
                                                    <input
                                                        type="text"
                                                        value={editableFormato.consentimiento || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, consentimiento: e.target.value })}
                                                        className="form-input w-fit py-1"
                                                        placeholder="Consentimiento"
                                                    />
                                                </div>
                                                <div className="flex justify-end gap-3">
                                                    <button
                                                        onClick={() => saveFormatoChanges(editableFormato)} // Guardar cambios
                                                        className="button-send"
                                                    >
                                                        Guardar
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setEditIndex(null); // Cancelar edición
                                                            setEditableFormato({}); // Reiniciar valores del formato editable
                                                        }}
                                                        className="button-gray"
                                                    >
                                                        Cancelar
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className='flex justify-between items-start'>
                                                    <div className="grid gap-2">
                                                        <p><strong>Nombre:</strong> {consentimiento.nombreConsentimiento}</p>
                                                        <p><strong>Servicio ligado:</strong> {consentimiento.servicioLigado}</p>
                                                        <p><strong>Consentimiento:</strong> {consentimiento.consentimiento}</p>
                                                    </div>
                                                </div>
                                                <div className='flex justify-end'>
                                                    <button
                                                        onClick={() => {
                                                            setEditIndex(`consentimiento-${index}`);
                                                            setEditableFormato(consentimiento); // Iniciar edición
                                                        }}
                                                        className="button-gray"
                                                    >
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div>
                                <h4 className="px-2 text-lg text-[#205087ff] font-bold">
                                    Historias
                                </h4>
                                <hr className="bg-[#205087ff] h-[2px] w-full" />
                                {clinicData.formatos?.historias?.map((historia, index) => (
                                    <div key={historia._id} className="my-3 p-4 bg-gray-200 rounded-lg">
                                        {editIndex === `historia-${index}` ? (
                                            <div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="text-gray-700 font-semibold">Nombre de la Historia Clínica</label>
                                                    <input
                                                        type="text"
                                                        value={editableFormato.nombreHC || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, nombreHC: e.target.value })}
                                                        className="form-input py-1 w-fit"
                                                        placeholder="Nombre de la Historia Clínica"
                                                    />
                                                </div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="text-gray-700 font-semibold">Servicio Ligado</label>
                                                    <select
                                                        value={editableFormato.servicioLigado || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, servicioLigado: e.target.value })}
                                                        className="form-input py-1 w-fit"
                                                    >
                                                        {clinicData.servicios.map((servicio) => (
                                                            <option key={servicio._id} value={servicio.service}>
                                                                {servicio.service}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="flex items-center form-group gap-2">
                                                    <label className="text-gray-700 font-semibold">Historia Clínica</label>
                                                    <input
                                                        type="text"
                                                        value={editableFormato.historiaClinica || ''}
                                                        onChange={(e) => setEditableFormato({ ...editableFormato, historiaClinica: e.target.value })}
                                                        className="form-input py-1 w-fit"
                                                        placeholder="Historia Clínica"
                                                    />
                                                </div>
                                                <div className="flex justify-end gap-3">
                                                    <button
                                                        onClick={() => saveFormatoChanges(editableFormato)} // Guardar cambios
                                                        className="button-send"
                                                    >
                                                        Guardar
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setEditIndex(null); // Cancelar edición
                                                            setEditableFormato({}); // Reiniciar valores del formato editable
                                                        }}
                                                        className="button-gray"
                                                    >
                                                        Cancelar
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className="grid gap-2">
                                                    <p><strong>Nombre:</strong> {historia.nombreHC}</p>
                                                    <p><strong>Servicio ligado:</strong> {historia.servicioLigado}</p>
                                                    <p><strong>Historia clínica:</strong> {historia.historiaClinica}</p>
                                                </div>
                                                <div className="flex justify-end">
                                                    <button
                                                        onClick={() => {
                                                            setEditIndex(`historia-${index}`);
                                                            setEditableFormato(historia); // Iniciar edición
                                                        }}
                                                        className="button-gray"
                                                    >
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );


            case 'insumos':
                return (
                    <div>
                        <h3 className="text-2xl font-bold mb-4">Insumos</h3>
                        {clinicData.insumos.inventario.map((insumo, index) => (
                            <div key={index} className="mb-4 p-4 bg-gray-100 rounded-lg shadow">
                                <p><strong>Producto:</strong> {insumo.producto}</p>
                                <p><strong>Cantidad:</strong> {insumo.cantidad}</p>
                                {/* Agregar otros campos de insumos según sea necesario */}
                            </div>
                        ))}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Contenedor icon={Perfil} title="Perfil de la clínica">
            <div className="flex flex-row overflow-x-auto mx-auto items-center justify-start bg-[#f79865ff] w-full rounded-tl-lg rounded-tr-lg">
                <div className="flex w-full">
                    <button
                        onClick={() => setActiveTab('perfil')}
                        className={`flex-1 px-5 py-2 rounded-tl-lg rounded-tr-lg ${activeTab === 'perfil' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} border-r border-[#f4ac84] focus:outline-none`}
                    >
                        Perfil
                    </button>
                    {/*
                    <button
                        onClick={() => setActiveTab('sedes')}
                        className={`flex-1 px-5 py-2  rounded-tl-lg rounded-tr-lg ${activeTab === 'sedes' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} border-r border-[#f4ac84] focus:outline-none`}
                    >
                        Sedes
                    </button>
                    <button
                        onClick={() => setActiveTab('capacidades')}
                        className={`flex-1 px-5 py-2  rounded-tl-lg rounded-tr-lg ${activeTab === 'capacidades' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} border-r border-[#f4ac84] focus:outline-none`}
                    >
                        Capacidades
                    </button>
                    <button
                        onClick={() => setActiveTab('servicios')}
                        className={`flex-1 px-5 py-2  rounded-tl-lg rounded-tr-lg ${activeTab === 'servicios' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} border-r border-[#f4ac84] focus:outline-none`}
                    >
                        Servicios
                    </button>
                    <button
                        onClick={() => setActiveTab('formatos')}
                        className={`flex-1 px-5 py-2  rounded-tl-lg rounded-tr-lg ${activeTab === 'formatos' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} border-r border-[#f4ac84] focus:outline-none`}
                    >
                        Formatos
                    </button>
                    <button
                        onClick={() => setActiveTab('insumos')}
                        className={`flex-1 px-5 py-2  rounded-tl-lg rounded-tr-lg ${activeTab === 'insumos' ? 'text-white bg-[#205087ff]' : 'text-[#205087ff]'} focus:outline-none`}
                    >
                        Insumos
                    </button>
                    */}
                </div>
            </div>
            <div className="p-3 max-h-[550px] overflow-auto">
                {renderTabContent()}
            </div>
        </Contenedor>
    );
};

export default ClinicProfile;
